import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ForbiddenComponent } from './forbidden.component';

@NgModule({
  declarations: [ForbiddenComponent],
  imports: [CommonModule],
  exports: [ForbiddenComponent]
})
export class ForbiddenModule {}
